import React from "react";
import { Route } from "react-router-dom";
import ItemDetail from "../items/ItemDetail";
import ItemAdd from "../items/ItemAdd";
import ItemEdit from "../items/ItemEdit";


const allItemRoutes = () => (
  
  <>
    <Route
      path="/department/production-dashboard/item-list/add-item"
      element={<ItemAdd />}
    />
    <Route
      path="/department/production-dashboard/item-list/item/:slug/edit"
      element={<ItemEdit />}
    />
    <Route
      path="/department/production-dashboard/item-list/item/:slug"
      element={<ItemDetail />}
    />
  </>
);

export default allItemRoutes;
